<script>
import { mapGetters } from "vuex";
import {
  MDBContainer, 
  MDBRow, 
  MDBCol, 
  MDBTabs,
  MDBTabNav,
  MDBTabContent,
  MDBTabItem,
  MDBTabPane
} from "mdb-vue-ui-kit";
import { scroller } from "vue-scrollto/src/scrollTo";
import clientConfig from '/src/config/client';

import HeaderFragment from './HeaderFragment.vue'
import AboutPanel from './AboutPanel.vue';
import WelcomePanel from './WelcomePanel.vue';
import ContributionPanel from "./ContributionPanel.vue";
import ResultPanel from './ResultPanel.vue'
import NextPanel from './NextPanel.vue'
import DisclaimerAndAssumptionsPanel from './DisclaimerAndAssumptions.vue'

export default {
  name: 'CalculatorScaffold',

  components: {
    MDBContainer,
    MDBRow,
    MDBCol,
    MDBTabs,
    MDBTabNav,
    MDBTabContent,
    MDBTabItem,
    MDBTabPane,
    HeaderFragment,
    AboutPanel,
    WelcomePanel,
    ResultPanel,
    NextPanel,
    ContributionPanel,
    DisclaimerAndAssumptionsPanel
  },

  setup() {},

  mounted() {
    document.querySelector("#mainNav")
      .addEventListener('keydown', this.handleAccessibleTabs, true);
  },

  beforeUnmount() {
    document.querySelector("#mainNav")
      .removeEventListener('keydown', this.handleAccessibleTabs);
  },

  computed: {
    ...mapGetters([
      "debugMode",
      "activeTab",
      "isResultTabActive",
    ]),

    currentYear() {
      return new Date().getFullYear();
    }
  },

  methods: {
    triggerHeightCheck() {
      // Add slight delay otherwise incorrect height is read
      var rf = this;
      setTimeout(function() {
        rf.$refreshIframeHeight();
      }, 300);
    },

    clickToTab(tabNum) {
      const scrollTo = scroller();
      this.$store.commit("setActiveTab", tabNum);
      scrollTo("#ccApp");
      
      this.triggerHeightCheck();
      
      this.$gtag.event('click', {
        'event_category': 'navigation',
        'event_label': 'navigateTo' + tabNum,
        'value': 1
      });
      
      if (this.debugMode)
        console.log("GTAG Event: navigateTo" + tabNum);
    },

    handleAccessibleTabs(event) {
      if (event.keyCode === 37 || event.keyCode === 39) { // Left or Right
        const currentTabPos = parseInt(event.srcElement.id.substring(event.srcElement.id.length - 1));
        if (event.keyCode === 37) { // Left
          if (currentTabPos <= 1) {
            document.querySelector("#tab-tab5").focus();
          } else {
            document.querySelector("#tab-tab" + (currentTabPos - 1)).focus();
          }
        } else if (event.keyCode === 39) { // Right
          if (currentTabPos >= 5) {
            document.querySelector("#tab-tab1").focus();
          } else {
            document.querySelector("#tab-tab" + (currentTabPos + 1)).focus();
          }
        }
      } else if (event.keyCode === 13 || event.keyCode === 32) {
        document.querySelector("#" + event.srcElement.id).click();
      }
    }
  },

  data() {
    return {
      clientConfig,
      tabNames: [
        clientConfig.content.general.tabLabels.welcomeTab,
        clientConfig.content.general.tabLabels.aboutTab,
        clientConfig.content.general.tabLabels.contributionTab,
        clientConfig.content.general.tabLabels.calculationTab,
        clientConfig.content.general.tabLabels.whatsNextTab
      ]
    }
  },
}
</script>

<template>
  <MDBContainer>
    <MDBRow class="p-0 mt-4">
      <MDBCol 
        col="12"
        sm="11"
        class="p-0 mx-auto"
      >
        <MDBContainer fluid>
          <MDBRow class="p-0">
            <MDBCol
              col="12"
            >
            </MDBCol>

            <MDBCol 
              col="12"
              class="p-0"
            >
              <div class="logo" role="img" aria-label="Company Logo"></div>

              

              <MDBTabs :modelValue="'tab' + activeTab">
                <MDBTabNav 
                  pills 
                  tabsClasses="calc-nav" 
                  role="tablist" 
                  aria-label="Navigation Tabs" 
                  id="mainNav"
                >
                  <MDBTabItem 
                    tabId="tab1" 
                    :tabindex="activeTab === 1 ? 0 : -1"
                    role="tab" 
                    aria-controls="tab1" 
                    :aria-label="tabNames[0]"
                    :aria-selected="activeTab === 1 ? 'true' : 'false'"
                    @click="clickToTab(1)"
                    class="welcome"
                  >
                    {{ tabNames[0] }}
                  </MDBTabItem>

                  <MDBTabItem 
                    tabId="tab2" 
                    :tabindex="activeTab === 2 ? 0 : -1" 
                    role="tab" 
                    aria-controls="tab2"
                    :aria-label="tabNames[1]"
                    :aria-selected="activeTab === 2 ? 'true' : 'false'"
                    @click="clickToTab(2)"
                    class="about"
                  >
                    {{ tabNames[1] }}
                  </MDBTabItem>

                  <MDBTabItem 
                    tabId="tab3" 
                    :tabindex="activeTab === 3 ? 0 : -1" 
                    role="tab" 
                    aria-controls="tab3"
                    :aria-label="tabNames[2]"
                    :aria-selected="activeTab === 3 ? 'true' : 'false'"
                    @click="clickToTab(3)"
                    class="contributions"
                  >
                    {{ tabNames[2]}}
                  </MDBTabItem>
                  
                  <MDBTabItem 
                    tabId="tab4" 
                    :tabindex="activeTab === 4 ? 0 : -1"
                    role="tab" 
                    aria-controls="tab4"
                    :aria-label="tabNames[3]"
                    :aria-selected="activeTab === 4 ? 'true' : 'false'"
                    @click="clickToTab(4)"
                    class="result"
                    :class="{'disabled': !isResultTabActive }"
                  >
                    {{ tabNames[3]}}
                  </MDBTabItem>

                  <MDBTabItem
                    tabId="tab5"
                    :tabindex="activeTab === 5 ? 0 : -1"
                    role="tab"
                    aria-controls="tab5"
                    :aria-label="tabNames[4]"
                    :aria-selected="activeTab === 5 ? 'true' : 'false'"
                    @click="clickToTab(5)"
                    class="info"
                  >
                    {{ tabNames[4]}}
                  </MDBTabItem>
                </MDBTabNav>

                <MDBTabContent>
                  
                  <MDBTabPane tabId="tab1" tabindex="0" role="tabpanel" aria-labelledby="tab-tab1">
                    <HeaderFragment />
                    <div class="p-0 frame-border welcome-page">
                      <WelcomePanel />
                    </div>
                  </MDBTabPane>

                  <MDBTabPane tabId="tab2" tabindex="0" role="tabpanel" aria-labelledby="tab-tab2">
                    <HeaderFragment :title="clientConfig.content.about.bannerHeading" />
                    <div class="p-0 frame-border about-page">
                      <AboutPanel />
                    </div>
                  </MDBTabPane>

                  <MDBTabPane tabId="tab3" tabindex="0" role="tabpanel" aria-labelledby="tab-tab3">
                    <HeaderFragment :title="clientConfig.content.contributions.bannerHeading" />
                    <div class="p-0 frame-border quote-page">
                      <ContributionPanel />
                    </div>
                  </MDBTabPane>

                  <MDBTabPane tabId="tab4" tabindex="0" role="tabpanel" aria-labelledby="tab-tab4">
                    <HeaderFragment :title="clientConfig.content.calculation.bannerHeading" />
                    <div class="p-0 frame-border next-page">
                      <ResultPanel />
                    </div>
                  </MDBTabPane>

                  <MDBTabPane tabId="tab5" tabindex="0" role="tabpanel" aria-labelledby="tab-tab5">
                    <HeaderFragment :title="clientConfig.content.whatsnext.bannerHeading" />
                    <div class="p-0 frame-border about-page">
                      <NextPanel />
                    </div>
                  </MDBTabPane>

                   <MDBTabPane tabId="tab6" tabindex="0" role="tabpanel" aria-labelledby="tab-tab6">
                    <HeaderFragment :title="clientConfig.content.disclaimer.bannerHeading" />
                    <div class="p-0 frame-border about-page">
                      <DisclaimerAndAssumptionsPanel />
                    </div>
                  </MDBTabPane>
                </MDBTabContent>

                <footer class="main-footer">
                  <!-- <a href="https://www.gallaghercommunications.com.au" class="g-logo" target="_blank" alt="Gallagher Logo"></a> -->
                  <div class="footer-text">
                    Built by Gallagher © {{ currentYear }}
                    <a href="javascript:;" @click="clickToTab(6)" class="internal-link disclaimer-link">Disclaimer and Assumptions</a>
                  </div>
                </footer>

              </MDBTabs>
            </MDBCol>
          </MDBRow>
        </MDBContainer>

      </MDBCol>
    </MDBRow>
  </MDBContainer>
</template>